/* RESTAURATIONSBRANCHEN - TEMA 2 */
const gameSteps = [
	{
		id: 'theme-2-2-video1',
		type: 'video',
		title: {
			da: 'Se filmen sammen',
			en: `Watch the video together`
		},
		videos: [
			{id: {da: 'ye-Rc4_Os0Q', en: '7ROGTLh_hug'}, thumbnail: 'theme-2-2-video1'}
		],
		nextBtn: null,
		nextBtnConditions: []
	},
	{
		id: 'theme-2-2-question1',
		type: 'questions',
		title: {
			da: 'Vælg en handling',
			en: `Choose an action`
		},
		text: {
			da: `Hvad synes I Julie skal gøre?`,
			en: `What do you think Julie should do?`
		},
		nextBtn: null,
		questions: [
			{
				id: 'theme-2-2-question1-question',
				type: 'multiple-choice',
				options: [
					{
						id: 1,
						text: {
							da: `Julie skal insistere mere på at blive hørt i situationen.`,
							en: `Julie should insist on being heard in the situation.`
						},
					},
					{
						id: 2,
						text: {
							da: `De to andre skal tage fat i Julie senere og høre, hvorfor hun blev lidt tavs.`,
							en: `The two others should talk to Julie about it later and ask why she fell a bit silent.`
						}
					},
				]
			}
		]
	},
	{
		id: 'theme-2-2-video2',
		type: 'video',
		title: {
			da: 'Se filmen sammen',
			en: `Watch the video together`
		},
		videos: [
			{
				id: {da: 'fqiLHXsZiJw', en: 'yWFUpqnVfxE'}, 
				thumbnail: 'theme-2-2-video2a',
				conditions: [{type: 'question-option-selected', questionId: 'theme-2-2-question1-question', optionId: 1}]
			},
			{
				id: {da: 'LnYc07G19K0', en: '5o86IMwprf8'}, 
				thumbnail: 'theme-2-2-video2b',
				conditions: [{type: 'question-option-selected', questionId: 'theme-2-2-question1-question', optionId: 2}]
			},
		],
		nextBtn: null,
		nextBtnConditions: []
	},
	{
		id: 'theme-2-2-dilemma',
		type: 'questions',
		subtype: 'dilemma',
		title: {
			da: `Tal i gruppen`,
			en: `Discuss in your group`
		},
		text: {
			da: `Forestil jer, at det samme sker for Julie en uges tid senere. Igen bliver hendes idéer ignoreret. Hvad skal Julie gøre i sådan en situation?
				<br /><br />Tal om det i gruppen, og vælg en mulighed.`,
			en: `Imagine that the same thing happens to Julie about a week later. Once again, her ideas are ignored. What should Julie do in such a situation?
				<br /><br />Discuss this in the group and choose one option.`
		},
		nextBtn: null,
		questions: [
			{
				id: 'theme-2-2-dilemma-question',
				type: 'multiple-choice',
				subtype: 'dilemma',
				options: [
					{
						id: 1,
						text: {
							da: `Ikke noget. Man kan ikke forvente en masse ændringer på så kort tid.`,
							en: `Nothing. You can't expect a lot of changes in such a short timeframe.`
						},
					},
					{
						id: 2,
						text: {
							da: `Hun skal spørge direkte, om der er noget galt med hendes ideer.`,
							en: `She should ask directly if something is wrong with her ideas.`
						}
					},
					{
						id: 3,
						text: {
							da: `Hun skal sige noget i situationen. Det er ikke sikkert, at Nis og Lisa tænker over det.`,
							en: `She should speak up in the situation. Maybe Nis and Lisa don't think about it.`

						}
					},
				]
			}
		]
	},
	// {
	// 	id: 'theme-2-2-dilemma-result',
	// 	type: 'dilemma-result',
	// 	dilemmaGameStepId: 'theme-2-2-dilemma',
	// 	dilemmaQuestionId: 'theme-2-2-dilemma-question',
	// 	title: {
	// 		da: 'Andre, der har prøvet forløbet, har svaret:',
	// 		en: `Others who've used this tool have answered:`
	// 	},
	// 	nextBtn: {
	// 		da: 'Videre',
	// 		en: 'Next'
	// 	}
	// },
	{
		id: 'theme-2-2-discussion',
		type: 'text',
		title: {
			da: 'Jeres arbejdsplads',
			en: `Your workplace`
		},
		text1: {
			da: `Hvad gør du selv for, at andre skal føle sig godt tilpas?`,
			en: `What do you do to make others feel comfortable?`
		},
		text2: {
			da: `Tal om det i gruppen i tre-fem minutter, og tryk så "Videre".`,
			en: `Discuss this in the group for three to five minutes, then click "Next".`
		},
		nextBtn: {
			da: 'Videre',
			en: 'Next'
		},
		nextBtnConditions: [],
	},
	{
		id: 'theme-2-2-survey',
		type: 'survey',
		title: {
			da: 'Individuelle spørgsmål',
			en: `Individual questions`
		},
		text: {
			da: `I skal nu svare individuelt på nogle spørgsmål. Scan koden med jeres egne telefoner. Når alle spillere har scannet QR-koden, skal spilleren med denne telefon trykke "Videre" for at gå til de individuelle spørgsmål.`,
			en: `You will now answer some questions individually. Scan the code using your own phones. Once all players have scanned the QR code, the player with this phone should tap ‘Next’ to proceed to the individual questions.`
		},
		questions: [
			{ 
				id: 'theme-2-2-survey-q1',
				type: 'multiple-choice',
				// title: {
				// 	da: 'Spørgsmål 1',
				//	en: 'Question 1'
				// },
				text: {
					da: `Hvad oplever du som de største udfordringer, når det handler om at alle bliver set, hørt og respekteret? 
						<br /><br /><strong>Vælg 1 eller 2 svar og tryk så "Videre".</strong>`,
					en: `What do you see as the biggest obstacles when it comes to being seen, heard, and respected? 
						<br /><br /><strong>Choose 1 or 2 answers and then press "Next".</strong>`
				},
				maxNumberOfAnswers: 2,
				options: [
					{
						id: 1,
						text: {
							da: `Der bliver ikke taget nok hensyn til at vi er forskellige.`,
							en: `Not enough consideration is given to the fact that we are different.`
						},
					},
					{
						id: 2,
						text: {
							da: `Det kan være svært at sige sin mening, hvis man er uenig.`,
							en: `Voicing your opinion can be difficult when you disagree.`
						}
					},
					{
						id: 3,
						text: {
							da: `Der bliver hurtigt snakket videre, uden at der er tid til at høre alles mening.`,
							en: `The conversation continues quickly, without time to hear everyone's opinion.`
						}
					},
					{
						id: 4,
						text: {
							da: `Vi er ikke altid opmærksomme på hinandens grænser.`,
							en: `We are not always aware of each other's boundaries.`
						}
					},
					{
						id: 5,
						text: {
							da: `Det kan være svært at forstå hinanden fx. pga. forskellig baggrund, sprog eller erfaring.`,
							en: `It can be difficult to understand each other, for example due to different backgrounds, languages ​​or experiences.`
						}
					},
					{
						id: 6,
						text: {
							da: `Vi kommer hurtigt til at gøre, som vi plejer, i stedet for at høre nye idéer.`,
							en: `We quickly end up doing what we usually do instead of hearing new ideas.`
						}
					}
				]
			},
			{
				id: 'theme-2-2-survey-q2',
				type: 'multiple-choice',
				// title: {
				// 	da: 'Spørgsmål 2'
				// 	en: 'Question 2'
				// },
				text: {
					da: `Hvad er vigtigst for dig for at føle dig set, hørt og respekteret på din arbejdsplads? 
						<br /><br /><strong>Vælg 1 eller 2 svar og tryk så "Videre".</strong>`,
					en: `What is most important to you in order to feel seen, heard, and respected at work?
						<br /><br /><strong>Choose 1 or 2 answers and then press "Next".</strong>`
				},
				maxNumberOfAnswers: 2,
				options: [
					{
						id: 1,
						text: {
							da: `At jeg bliver lyttet til, når jeg siger noget.`,
							en: `That I am listened to when I say something.`
						}
					},
					{
						id: 2,
						text: {
							da: `At jeg kan være mig selv og føler mig accepteret.`,
							en: `That I can be myself and feel accepted.`
						}
					},
					{
						id: 3,
						text: {
							da: `At vi respekterer hinandens forskelligheder og grænser.`,
							en: `That we respect each other's differences and boundaries.`
						}
					},
					{
						id: 4,
						text: {
							da: `At jeg oplever at være en del af fællesskabet.`,
							en: `That I experience being part of the community.`
						}
					},
					{
						id: 5,
						text: {
							da: `At alle får mulighed for at sige deres mening.`,
							en: `That everyone gets the opportunity to express their opinion.`
						}
					},
					{
						id: 6,
						text: {
							da: `At vi tager os tid til at lære hinanden bedre at kende.`,
							en: `That we take the time to get to know each other better.`
						}
					}
				]
			}
		],
		finishedTitle: {
			da: `Tak for dine svar!`,
			en: `Thank you for answering!`
		},
		finishedText: {
			da: `Øvelsen er nu slut. Gå tilbage til start-lokalet.`,
			en: `The exercise is now over. Please return to the starting room.`
		},
		nextBtn: {
			da: 'Videre',
			en: 'Next'
		},
	}
];
	

export {
	gameSteps
};